// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.preview-container-program {
  display: flex;
  margin-top: 10px;
}
.preview-image-program {
  max-width: 150px;
  max-height: 150px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

`, "",{"version":3,"sources":["webpack://./src/component/utschoolz/Utschool.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;AACpB","sourcesContent":["\r\n.preview-container-program {\r\n  display: flex;\r\n  margin-top: 10px;\r\n}\r\n.preview-image-program {\r\n  max-width: 150px;\r\n  max-height: 150px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
